import React from 'react';
import { GoQuestion } from 'react-icons/go';
import { StyledIconWrapper, StyledTooltip } from './styles';
import { useTheme } from '@src/theme';

export interface IHelpTooltip {
    help: React.ReactNode;
    theme?: any;
    iconSize?: number;
}

export const HelpTooltip: React.FC<IHelpTooltip> = ({
    help,
    iconSize = 16,
}: Readonly<IHelpTooltip>) => {
    const { theme } = useTheme();
    return (
        <StyledTooltip title={help} placement="bottomLeft" arrow={false}>
            <StyledIconWrapper>
                <div
                    className="p-1 rounded-lg"
                    style={{
                        backgroundColor: theme.semantic.info,
                    }}
                >
                    <GoQuestion
                        style={{ color: theme.semantic.onInfo }}
                        size={iconSize}
                    />
                </div>
            </StyledIconWrapper>
        </StyledTooltip>
    );
};
